import { useTranslation } from 'react-i18next'

import {
  getMatchCriterionLabelKey,
  MATCH_SCORE_RING_SIZE,
  RentalPortalMatchChipsCell,
  RentalPortalMatchCriteriaPopover,
  RentalPortalMatchCriterionChip,
  RentalPortalMatchEligibilityBadge,
  RentalPortalMatchFitCell,
  RentalPortalMatchProvenanceDot,
  RentalPortalMatchProvenanceLegend,
  RentalPortalMatchScoreRing,
} from '../../RentalPortal'
import { Container } from '../Container'

import {
  MATCH_LIBRARY_ELIGIBLE,
  MATCH_LIBRARY_INCOMPLETE,
  MATCH_LIBRARY_NOT_ELIGIBLE,
  MATCH_LIBRARY_PROVENANCES,
  MATCH_LIBRARY_RING_SAMPLES,
  MATCH_LIBRARY_RING_SIZES,
} from './RentalPortalMatch.constants'

import * as styles from './RentalPortalMatch.module.css'

function RentalPortalMatch() {
  const { t } = useTranslation()

  return (
    <>
      <Container label='Eligibility badge — eligible, incomplete (first reason), not eligible (criterion of the first reason)'>
        <RentalPortalMatchEligibilityBadge match={MATCH_LIBRARY_ELIGIBLE} />
        <RentalPortalMatchEligibilityBadge match={MATCH_LIBRARY_INCOMPLETE} />
        <RentalPortalMatchEligibilityBadge match={MATCH_LIBRARY_NOT_ELIGIBLE} />
      </Container>
      <Container label='Criterion chip — fits, partial, does not fit, not provided, not applicable'>
        {MATCH_LIBRARY_ELIGIBLE.criteria.map(criterion => (
          <RentalPortalMatchCriterionChip
            criterion={criterion}
            key={criterion.key}
            text={t(getMatchCriterionLabelKey(criterion.key))}
          />
        ))}
      </Container>
      <Container label='Score ring — sizes 28 (table), 36 (tile), 48 (card header)'>
        {MATCH_LIBRARY_RING_SIZES.map(size => (
          <RentalPortalMatchScoreRing
            key={size}
            score={MATCH_LIBRARY_ELIGIBLE.score}
            size={size}
          />
        ))}
      </Container>
      <Container label='Score ring — one colour at every value'>
        {MATCH_LIBRARY_RING_SAMPLES.map(sample => (
          <RentalPortalMatchScoreRing
            key={sample.label}
            score={sample.score}
            size={MATCH_SCORE_RING_SIZE.tile}
          />
        ))}
      </Container>
      <Container label='Fit cell — score, insufficient coverage (n/m), not eligible (em dash)'>
        <RentalPortalMatchFitCell
          className={styles.fitCell}
          match={MATCH_LIBRARY_ELIGIBLE}
        />
        <RentalPortalMatchFitCell
          className={styles.fitCell}
          match={MATCH_LIBRARY_INCOMPLETE}
        />
        <RentalPortalMatchFitCell
          className={styles.fitCell}
          match={MATCH_LIBRARY_NOT_ELIGIBLE}
        />
      </Container>
      <Container label='Fit cell — card header ring size 48'>
        <RentalPortalMatchFitCell
          className={styles.fitCell}
          match={MATCH_LIBRARY_ELIGIBLE}
          ringSize={MATCH_SCORE_RING_SIZE.card}
        />
      </Container>
      <Container label='Chips cell — the first criteria as chips, +N for the rest, coverage'>
        <div className={styles.cell}>
          <RentalPortalMatchChipsCell match={MATCH_LIBRARY_ELIGIBLE} />
        </div>
      </Container>
      <Container label='Provenance dot (date in the tooltip) and legend — applicant, manual, Greta suggestion'>
        {MATCH_LIBRARY_PROVENANCES.map(provenance => (
          <RentalPortalMatchProvenanceDot
            key={provenance.source}
            provenance={provenance}
          />
        ))}
        <RentalPortalMatchProvenanceLegend />
      </Container>
      <Container label='Criteria popover — click the cell, Esc or outside click closes, bottom sheet below 848px'>
        <div className={styles.cell}>
          <RentalPortalMatchCriteriaPopover match={MATCH_LIBRARY_ELIGIBLE}>
            <RentalPortalMatchFitCell match={MATCH_LIBRARY_ELIGIBLE} />
          </RentalPortalMatchCriteriaPopover>
        </div>
      </Container>
    </>
  )
}

export default RentalPortalMatch
